<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <button
      mat-icon-button
      *ngIf="!_data?.selectedLocationEdit"
      (click)="onclose()"
    >
      <mat-icon class="material-icons font-bold text-blue-theme-color"
        >arrow_back</mat-icon
      >
    </button>
    <h2 mat-dialog-title class="!pl-0 dialog-heading capitalize">
      {{ heading }}
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    (click)="onclose()"
  >
    <mat-icon class="text-orange-color text-xl">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div
    class="w-full mb-3 cursor-pointer"
    (click)="openWhatToSendDialog()"
    matRipple
    *ngIf="!_data.isPickup"
  >
    <div class="flex gap-2 bg-superligth-silver px-3 py-1 rounded items-center">
      <mat-icon class="material-icons">info_outline</mat-icon>
      <span class="font-base font-semibold">What To Send</span>
      <mat-icon class="material-icons">chevron_right</mat-icon>
    </div>
  </div>

  <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
    <!-- Contact Person / Receiver Name -->
    <div class="flex flex-col md:flex-row md:gap-4 mt-6">
      <div class="flex-1">
        <label class="label font-medium mb-[4px]">{{
          _data.isPickup ? "Contact Person" : "Receiver Name"
        }}</label>
        <mat-form-field appearance="outline" class="w-full !mb-0">
          <input
            matInput
            formControlName="contactPerson"
            [placeholder]="
              _data.isPickup ? 'Enter Person Name' : 'Enter Receiver Name'
            "
          />
          <mat-error *ngIf="form.get('contactPerson')?.hasError('required')">
            {{
              _data.isPickup
                ? "Contact Person Required"
                : "Receiver Name Required"
            }}
          </mat-error>
          <mat-error *ngIf="form.get('contactPerson')?.hasError('pattern')"
            >Invalid Value</mat-error
          >
        </mat-form-field>
      </div>

      <!-- Contact Number -->
      <div class="flex-1 relative">
        <label class="label font-medium mb-[4px]">Contact Number</label>
        <mat-form-field appearance="outline" class="w-full !items-center !mb-0">
          <div matPrefix class="flex items-center gap-2 w-16">
            <mat-select
              tabindex="-1"
              [disabled]="true"
              [(value)]="selectedCountryCode"
            >
              <mat-option
                *ngFor="let country of countries"
                [value]="country.code.toString()"
              >
                <div class="flex flex-row gap-1">
                  <img class="w-6 object-contain" [src]="country.logo" alt="" />
                  <p>{{ country.code }}</p>
                </div>
              </mat-option>
            </mat-select>
          </div>
          <input
            matInput
            formControlName="personNumber"
            type="text"
            placeholder="Enter Mobile Number"
            [maxlength]="maxLength"
            (click)="$event.stopPropagation()"
            (paste)="onPaste($event)"
            appNoSpaces
          />
        </mat-form-field>
        <div class="flex flex-col absolute bottom-0 left-0">
          <span
            class="text-red text-xs font-medium mt-1"
            *ngIf="this.form.get('personNumber').hasError('pattern')"
            >Invalid number</span
          >
          <span
            class="text-red text-xs font-medium mt-1"
            *ngIf="
              this.form.get('personNumber').touched &&
              this.form.get('personNumber').hasError('required')
            "
            >Mobile number is required</span
          >
        </div>
      </div>
    </div>

    <!-- {{ _data.isInterRegional | json }} -->
    <!-- Cash Collection Amount -->
    <div *ngIf="!_data.isPickup && !_data.isInterRegional" class="">
      <label class="label font-medium mb-[4px]"
        >Collect payment upon delivery of your sold items</label
      >
      <mat-form-field class="w-full relative !mb-0" appearance="outline">
        <input
          formControlName="cashCollectionAmount"
          type="text"
          matInput
          class="mt-0"
          placeholder="Enter the Cash Collection Amount"
          appNoSpaces
          maxlength="7"
        />
        <button
          mat-icon-button
          (click)="openInfoDialog()"
          class="text-[#555] bg-white-color !absolute !right-[-10px] !top-[51%] !translate-y-[-50%]"
        >
          <mat-icon class="mat-18">info</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div
      *ngIf="!_data.isPickup && _data.isShowTrustCheck == 1"
      class="option-card mb-[20px]"
    >
      <img src="assets/images/bulkOrder/trustCheck.svg" class="w-[40px]" />
      <div class="flex justify-between items-start w-full">
        <div class="text-[#0B1640]">
          <div class="font-bold text-[18px]">Phlenu TrustCheck</div>
          <div class="text-[14px]">
            Our delivery personnel will verify your item at pickup to ensure
            accuracy and prevent fraud before delivery.
          </div>
        </div>
        <mat-slide-toggle formControlName="isPhlenuTrustCheckApplied">
        </mat-slide-toggle>
      </div>
    </div>

    <!-- Pickup / Drop Address -->
    <div class="">
      <div>
        <label class="label font-medium mb-[4px]">{{
          _data.isPickup ? "Pickup Address" : "Drop Address"
        }}</label>
        <mat-form-field class="w-full !mb-0" appearance="outline">
          <input
            matInput
            formControlName="pickupAddress"
            type="text"
            [placeholder]="
              _data.isPickup
                ? 'Enter Exact Pickup Location'
                : 'Enter Exact Dropoff Location'
            "
            (paste)="locationChange()"
            (input)="onAddressInput($event)"
            (keydown.enter)="$event.preventDefault()"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            #search
          />
          <mat-error *ngIf="form.get('pickupAddress')?.hasError('required')">
            Location is required
          </mat-error>
          <mat-error
            *ngIf="form.get('pickupAddress')?.hasError('addressNotSelected')"
          >
            Please select an address from the dropdown suggestions
          </mat-error>
          <mat-error
            *ngIf="form.get('pickupAddress')?.hasError('invalidGpsLocation')"
          >
            Selected location is not valid or outside service area
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-[14px] text-gray-500 -mt-[8px] mb-[20px]" *ngIf="_data.isInterRegional && !_data.isPickup">
        Tip: To avoid high prices, type the specific location in your area for
        example a town, city, or popular landmark not just the general area
        name.
      </div>
    </div>

    <!-- Google Map -->
    <div class="mb-5 input-bottom-border">
      <google-map
        height="200px"
        width="100%"
        [center]="{ lat: latitude, lng: longitude }"
        [zoom]="zoom"
        [options]="mapOptions"
      >
        <map-marker
          [position]="{ lat: latitude, lng: longitude }"
          [options]="markerOptions"
          (mapDragend)="markerDragEnd($event)"
        ></map-marker>
      </google-map>
    </div>

    <!-- Formatted Address -->
    <div *ngIf="formatedAddress" class="mb-4">
      <label class="block font-medium mb-1">Address</label>
      <p class="text-base md:text-lg font-medium text-black-color">
        {{ formatedAddress }}
      </p>
    </div>

    <!-- Landmark -->
    <div class="mb-4">
      <label class="label font-medium mb-[4px]">Landmark</label>
      <mat-form-field class="w-full" appearance="outline">
        <input matInput formControlName="landMark" placeholder="Enter Landmark" />
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="m-0 !pb-5 !px-5 flex justify-center">
  <button
    color="primary"
    (click)="onSubmit()"
    class="!bg-blue-theme-color !px-6 !h-11 text-white-color !rounded ml-auto"
    mat-flat-button
    [disabled]="form.invalid"
  >
    <span class="btn-text">
      {{
        _data.isPickup ? "Confirm Pickup Location" : "Confirm Dropoff Location"
      }}
    </span>
  </button>
</mat-dialog-actions>
